import React from "react";
import { Link } from 'react-router-dom';
const Service = ({image, title, description, link}) => {
    return (
        <Link to={'./' + link} className="block no-underline">
            <div className="mx-auto mb-6 flex max-w-6xl flex-col items-center gap-6 p-6 shadow-md transition duration-300 hover:scale-[1.02] hover:bg-neutral-100 md:flex-row md:p-8">
                <div className="flex-1 text-center">
                    <h1 className="mb-4 text-2xl font-bold text-neutral-800 md:text-4xl">{title}</h1>
                    <p className="text-sm leading-relaxed text-neutral-600 sm:text-base md:text-xl">{description}</p>
                </div>
                <img className="h-64 w-full max-w-md object-cover md:h-[45vh] md:w-2/5" src={image} alt={title}></img>
            </div>
        </Link>
    );
};

export default Service
